/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  SubscriptionUserControllerPurchaseMutationRequest,
  SubscriptionUserControllerPurchaseMutationResponse,
  SubscriptionUserControllerPurchasePathParams,
  SubscriptionUserControllerPurchase401,
} from '../types/SubscriptionUserControllerPurchase.ts';

function getSubscriptionUserPurchaseUrl(planId: SubscriptionUserControllerPurchasePathParams['planId']) {
  const res = { method: 'POST', url: `/api/user/telegram/subscriptions/plans/${planId}` as const };
  return res;
}

/**
 * {@link /api/user/telegram/subscriptions/plans/:planId}
 */
export async function subscriptionUserPurchase(
  planId: SubscriptionUserControllerPurchasePathParams['planId'],
  data?: SubscriptionUserControllerPurchaseMutationRequest,
  config: Partial<RequestConfig<SubscriptionUserControllerPurchaseMutationRequest>> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    SubscriptionUserControllerPurchaseMutationResponse,
    ResponseErrorConfig<SubscriptionUserControllerPurchase401>,
    SubscriptionUserControllerPurchaseMutationRequest
  >({
    method: 'POST',
    url: getSubscriptionUserPurchaseUrl(planId).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}
